import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./Redux/store";
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import COLORS from './common/Colors';



const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

const customTheme = {
  token: {
    colorPrimary: COLORS.SIDEBAR
  },
};
root.render(
    <Router>
    <ConfigProvider theme={customTheme}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
      </Provider>
      </ConfigProvider>
    </Router>
);

reportWebVitals();
